"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiIcon = _interopRequireDefault(require("@tencent/spaui-icon"));

var _info = _interopRequireDefault(require("./info"));

var _blockselector_props = require("./blockselector_props");

var _index = require("./utils/index");

var _item_component = _interopRequireDefault(require("./component/item_component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var BlockSelector =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(BlockSelector, _PureComponent);

  function BlockSelector(props) {
    var _this;

    _classCallCheck(this, BlockSelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BlockSelector).call(this, props));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BlockSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event, value) {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          propsValue = _this$props.value,
          _this$props$multiple = _this$props.multiple,
          multiple = _this$props$multiple === void 0 ? false : _this$props$multiple;
      var checked = event.target.checked || false;
      var result = multiple ? [] : '';
      var index = -1;

      if ((0, _spauiUtils.isFunction)(onChange)) {
        if (multiple) {
          if (propsValue) {
            // 先把原来全部放到result
            if ((0, _spauiUtils.isArray)(propsValue)) {
              result = [];
              propsValue.map(function (item) {
                result.push(item);
                return item;
              });
            } else {
              result = [propsValue];
            } // 根据是否选中加入或者剔除


            if (checked) {
              result.push(value);
            } else {
              index = result.indexOf(value);

              if (index > -1) {
                result.splice(index, 1);
              }
            }
          }
        } else if (checked) {
          result = value;
        }

        onChange(event, result);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          data = _this$props2.data,
          _this$props2$disabled = _this$props2.disabled,
          propsDisabled = _this$props2$disabled === void 0 ? false : _this$props2$disabled,
          propsValue = _this$props2.value,
          render = _this$props2.render;
      return _react["default"].createElement("div", _extends({
        "data-toggle": "buttons"
      }, (0, _spauiUtils.globalProps)(this.props, {
        className: 'spaui-blockselector'
      }, BlockSelector)), data.map(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var value = item.value,
            children = item.children,
            label = item.label,
            _item$disabled = item.disabled,
            disabled = _item$disabled === void 0 ? false : _item$disabled,
            _item$style = item.style,
            style = _item$style === void 0 ? {} : _item$style,
            _item$className = item.className,
            className = _item$className === void 0 ? '' : _item$className;
        var statusConfig = {
          disabled: propsDisabled || disabled || false,
          checked: (0, _index.isChecked)(propsValue, value)
        }; // 给itemComponent提供的属性

        var itemComponentProps = _objectSpread({
          className: className,
          style: style,
          value: value
        }, statusConfig, {
          key: value,
          onChange: function onChange(event) {
            return _this2.handleChange(event, value);
          }
        });

        var customChildren;
        var result = null;

        if (typeof value !== 'undefined') {
          // 看看是否有自定义子结构
          if ((0, _spauiUtils.isFunction)(render)) {
            customChildren = render(value, item, statusConfig);
          } else {
            customChildren = children;
          } // 如果有自定义结构的就先用这个展示


          if (typeof customChildren !== 'undefined') {
            result = _react["default"].createElement(_item_component["default"], itemComponentProps, customChildren);
          } else {
            result = _react["default"].createElement(_item_component["default"], itemComponentProps, _react["default"].createElement("div", {
              className: "radio-block-txt"
            }, typeof label === 'string' ? _react["default"].createElement("p", null, _react["default"].createElement("span", {
              dangerouslySetInnerHTML: {
                __html: label
              }
            })) : label), _react["default"].createElement("span", {
              className: "caret"
            }, _react["default"].createElement(_spauiIcon["default"], {
              type: "checkmark",
              size: "small"
            })));
          }
        }

        return result;
      }));
    }
  }]);

  return BlockSelector;
}(_react.PureComponent); // 组件标记


_defineProperty(BlockSelector, "propTypes", _blockselector_props.propTypes);

_defineProperty(BlockSelector, "defaultProps", _blockselector_props.defaultProps);

(0, _spauiUtils.setComponentMark)(BlockSelector, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = BlockSelector;
exports["default"] = _default;